<template>
    <div>
        <config-main-title v-if="!no_faturamento">
            Validação Geral Preços por Operadora
        </config-main-title>

        <sub-menu-faturamento ativo="precos" v-else></sub-menu-faturamento>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-3">
                        <az-input 
                            type="select" 
                            placeholder="Todas as Especialdiades..."
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            :optionsReload="true"
                            v-model="especialidade">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="id_unidade_operacao">
                                <option value="">Unidades...</option>
                                <option v-for="(und, iux) in lista_unidades" 
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Operadora/Plano..."
                            icon="far fa-credit-card"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsName="planos.atendimento"
                            :optionsParm="{ 
                                atendimento: true, 
                                plano_id_unidade_operacao: null 
                            }"
                            service="planos.index"
                            :optionsSync="false"
                            v-model="novo_plano">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1"
                                        :disabled="!novo_plano || planos.length >= 5" @click="incluir_plano(novo_plano)">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'P', search: 'Procedimentos' },
                                { id: 'C', search: 'Combos' },
                            ]"
                            v-model="tipo_proc" 
                            @input="page = 1; dados = null;">
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-play fa-fw"
                            placeholder="Classe do Procedimento..."
                            type="select" 
                            optionsMode="aql"
                            optionsName="procedimentos.index" 
                            optionsData="id"
                            :optionsParm="{ ativos: true, filtro: true, tags: true }"
                            service="procedimentos.index"
                            v-model="filtro.tag_procedimento" />
                    </div>
                    <div class="col col-12 col-md-9">
                        <az-input
                            icon="fa fa-play fa-fw"
                            placeholder="Procedimento..."
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsName="procedimentos.index" 
                            optionsData="id_procedimento"
                            :optionsParm="{ ativos: true }"
                            service="procedimentos.index"
                            v-model="filtro.id_procedimento" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-3">
                        <az-input   
                            icon="fa-solid fa-magnifying-glass-dollar"
                            type="select"
                            placeholder="Valor do Procedimento"
                            :optionsList="[
                                { id: 'T', search: 'Valor Total' },
                            ]"
                            optionsData="id"
                            edicao2="planos && planos.length > 1"
                            v-model="tipo_show_valor" />
                    </div>
                    <div class="col col-12 col-md-9">
                        <az-input
                            icon="fa fa-search fa-fw"
                            v-model="search" 
                            @input="page = 1">
                            <template v-slot:buttonposb>
                                <print-export printid="lista-lancamentos" :dados="dadosFormatados" :left="true" />
                            </template>
                        </az-input>
                    </div>
                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista.length && planos.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="planos && planos.length" class="mb-3">
            <div class="btn-group mr-2" role="group" aria-label="Third group" v-for="(plano, ipx) in planos" :key="ipx">
                <button type="button" class="btn btn-danger" @click="remover_plano(ipx)">
                    <i class="fa fa-minus" aria-hidden="true"></i>
                </button>
                <button type="button" class="btn btn-secondary" @click="$util.abrirOperadora(plano)">{{ plano.search }}</button>
            </div>
        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state icon="fas fa-filter" msg="Selecione a Especialidade" v-if="!especialidade" />
            <az-empty-state msg="Selecione a(s) Operadora(s)" v-else-if="!planos || !planos.length" />
			<az-empty-state msg="Realizar Pesquisa de Preços" action="Buscar" :method="load" v-else />
        </div>

        <div id="lista-lancamentos" v-else>

            <div class="row d-print-none mb-3">
                <div class="col col-12 col-md-6">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" 
                            id="com-precos" 
                            v-model="apenas_com_precos">
                        <label class="custom-control-label" for="com-precos">Exibir apenas items com preço</label>
                    </div>
                </div>
                <div class="col col-12 col-md-3">
                    <az-input
                        class="mb-0"
                        sizing="sm"
                        v-if="preco_detalhado"
                        type="button-group"
                        :optionsList="[
                            { id: 'V', search: 'Valores' },
                            { id: 'I', search: 'Índices' },
                        ]"
                        v-model="tipo_valores" />
                </div>
                <div class="col col-12 col-md-3 text-right">
                    <span class="badge badge-secondary">{{ lista.length }}</span>
                </div>
            </div>

            <cabecalho-generico titulo="Preços x Operadoras">
                <div v-if="planos && preco_detalhado">
                    {{ planos[0].search }}
                </div>
            </cabecalho-generico>

            <table class="table table-hover bg-white cabecalho-fixo">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>{{ tipo_proc == 'C' ? 'Combo' : 'Procedimento' }}</th>
                        <template v-if="preco_detalhado">
                            <th>Tabela</th>
                            <th>Código</th>
                            <th class="text-right"><span title="Porte Anestésico">PA</span></th>
                            <th class="text-right"><span title="Número de Auxiliares">Aux</span></th>
                            <th class="text-right"><span title="Metragem de Filme">Filme</span></th>
                            <th class="text-right">Valor</th>
                            <th class="text-right"><span title="Custo Operacional">CO</span></th>
                            <th class="text-right text-nowrap">Valor R$</th>
                            <template v-if="tipo_show_valor == 'T'">
                                <th class="text-right"><span title="Custo Operacional">Mat/Med</span></th>
                                <th class="text-right"><span title="Custo Operacional">Taxa</span></th>
                                <th class="text-right text-nowrap">Total</th>
                            </template>
                        </template>
                        <template v-else>
                            <th v-for="(plano, ipx) in planos" :key="ipx" class="text-right">
                                <small>{{ plano.search }}</small>
                            </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(proced, ipx) in lista">
                        <!-- ( !apenas_com_precos || planos.length != 1 || proced.precos[planos[0].id_plano].valor > 0 ) -->
                        <tr :key="ipx" v-if="true" v-show="tem_preco(proced)" :class="proced.nao_cobre ? 'table-secondary' : ''">
                            <td>#{{ proced.id_procedimento }}</td>
                            <td><small>{{ proced.search }}</small>
                                <i class="fa fa-ban ml-2" aria-hidden="true" title="Sem cobertura" v-if="proced.nao_cobre"></i>
                            </td>
                            <template v-if="preco_detalhado">
                                <template v-if="proced.precos[planos[0].id_plano] && proced.precos[planos[0].id_plano].valor && proced.precos[planos[0].id_plano].item_tabela">
                                    <td>
                                        <pre v-if="false">{{ proced.precos[planos[0].id_plano] }}</pre>
                                        <small v-if="proced.precos[planos[0].id_plano].item_tabela.tabela_versao">
                                            {{ proced.precos[planos[0].id_plano].item_tabela.tabela_versao.search }}
                                        </small>
                                    </td>
                                    <td class="small">
                                        {{ proced.precos[planos[0].id_plano].item_tabela.st_codigo }}
                                    </td>
                                    <td class="text-right small">
                                        {{ proced.precos[planos[0].id_plano].item_tabela.in_porte_anestesico }}
                                    </td>
                                    <td class="text-right small">
                                        {{ proced.precos[planos[0].id_plano].item_tabela.in_numero_auxiliares }}
                                    </td>
                                    <td class="text-right small">
                                        <span v-if="proced.precos[planos[0].id_plano].item_tabela.dc_filme > 0">
                                            <span v-if="tipo_valores == 'V'">
                                                {{ $util.formatMoeda(proced.precos[planos[0].id_plano].valor_filme) }}
                                            </span>
                                            <span v-else>
                                                {{ $util.formatNumber(proced.precos[planos[0].id_plano].item_tabela.dc_filme, 4) }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="text-right small">
                                        <span v-if="tipo_valores == 'V'">
                                            {{ $util.formatMoeda(proced.precos[planos[0].id_plano].valor_hm) }}
                                        </span>
                                        <template v-else>
                                            <span class="badge badge-secondary mr-1" 
                                                v-if="proced.precos[planos[0].id_plano].item_tabela.moeda && !proced.precos[planos[0].id_plano].item_tabela.tabela_versao.fl_moeda_corrente">
                                                {{ proced.precos[planos[0].id_plano].item_tabela.moeda.st_moeda }}
                                            </span>
                                            {{ $util.formatMoeda(proced.precos[planos[0].id_plano].item_tabela.dc_valor) }}
                                        </template>
                                    </td>
                                    <td class="text-right small">
                                        <span v-if="!proced.precos[planos[0].id_plano].item_tabela.tabela_versao.fl_moeda_corrente && proced.precos[planos[0].id_plano].item_tabela.moeda_corrente != 'S'">
                                            <span v-if="tipo_valores == 'V'">
                                                {{ $util.formatMoeda(proced.precos[planos[0].id_plano].valor_co) }}
                                            </span>
                                            <span v-else>
                                                {{ $util.formatMoeda(proced.precos[planos[0].id_plano].item_tabela.dc_custo_operacional) }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="text-right small">
                                        <template v-if="proced.precos[planos[0].id_plano].item_tabela">
                                            <template v-if="proced.precos[planos[0].id_plano].item_tabela.tabela_operadora">
                                                <a href="#" @click.prevent="exibir_moeda_corrente(proced.precos[planos[0].id_plano].item_tabela)" class="card-link mr-1" title="Detalhe do Cálculo do Valor">
                                                    <i class="fas fa-search-dollar"></i>
                                                </a>
                                            </template>
                                            <a href="#" class="card-link ml-1" title="Valor em Real. Clique para visualizar a tabela."
                                                @click.prevent="abrir_item_tabela(proced.precos[planos[0].id_plano].item_tabela)">
                                                {{ $util.formatMoeda(proced.precos[planos[0].id_plano].valor) }}
                                            </a>
                                        </template>
                                        <span v-else>
                                            {{ $util.formatMoeda(proced.precos[planos[0].id_plano].valor) }}
                                        </span>
                                    </td>
                                    <template v-if="tipo_show_valor == 'T'">
                                        <td class="text-right small">
                                            {{ $util.formatMoeda(consolidar_consumo(proced.precos[planos[0].id_plano], 'M')) }}
                                        </td>
                                        <td class="text-right small">
                                            {{ $util.formatMoeda(consolidar_consumo(proced.precos[planos[0].id_plano], 'T')) }}
                                        </td>   
                                        <td class="text-right small">
                                            {{ $util.formatMoeda(proced.precos[planos[0].id_plano].valor
                                                + consolidar_consumo(proced.precos[planos[0].id_plano])) }}
                                        </td>
                                    </template>
                                </template>
                                <template v-else>
                                    <td colspan="11"></td>
                                </template>
                            </template>
                            <template v-else>
                                <td v-for="(plano, ipx) in planos" :key="ipx" class="text-right">
                                    <span v-if="proced.precos[plano.id_plano] && proced.precos[plano.id_plano].valor">
                                        <a href="#" v-if="proced.precos[plano.id_plano].item_tabela" class="card-link"
                                            @click.prevent="abrir_item_tabela(proced.precos[plano.id_plano].item_tabela)">
                                            {{ 
                                                $util.formatMoeda(
                                                    proced.precos[plano.id_plano].valor
                                                    + consolidar_consumo(proced.precos[plano.id_plano])
                                                ) 
                                            }}
                                        </a>
                                        <span v-else>
                                            {{ $util.formatMoeda(proced.precos[plano.id_plano].valor) }}
                                        </span>
                                    </span>
                                </td>
                            </template>
                        </tr>
                    </template>
                </tbody>
            </table>

        </div>

        <pre v-if="false">{{ dadosFormatados }}</pre>

        <cadastro-item-tabela ref="cadtab" :view="no_faturamento" />
        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import CadastroItemTabela from '../shared/CadastroItemTabela.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import SubMenuFaturamento from '../../modulos/faturamento/SubMenuFaturamento.vue';

export default {
    data () { 
        return { 
            dados: null, 
            tabelas: null, 
            campo_valid: "", 
            page: 1, 
            search: "", 
            especialidade: "", 
            procedimento: "",
            tabela: "", 
            itemTabelaVinculo: "", 
            filtro_tabela: "", 
            filtro_plano: "", 
            tipo: "O",
            particulares: [], 
            novo_plano: "", 
            valor_partic: "", 
            planos: [], 
            id_unidade_operacao: "", 
            apenas_com_precos: true, 
            tipo_valores: "V", 
            tipo_proc: 'P',
            tipo_show_valor: "", 
            filtro: { 
                tag_procedimento: "",
                id_procedimento: "",
            }
        }
    },

    components: { 
        AzInput,
        AzEmptyState,
        ConfigMainTitle, 
        CadastroItemTabela, 
        PrintExport, 
        CabecalhoGenerico, 
        SubMenuFaturamento, 
    },

    props: ['id_operadora'],

    computed: { 
        preco_detalhado: function () { 
            return this.planos 
                && this.planos.length == 1 
                // && this.planos[0].id_operadora != 1 
                && this.tipo_proc != 'C';
        },

        lista_unidades: function () { 
            return _.orderBy(
                this.$store.state.unidade.unidade_operacaos.filter(item => !item.fl_unidade_adm),
                'st_nome'
            );
        },

        total_paginas: function () { 
            if ( !this.dados )
                return 0;

            return Math.ceil(this.dados.length / 100);
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            const retorno = this.dados.filter(item => !this.especialidade || item.id_especialidade == this.especialidade.id_especialidade)
                .filter(proced => ( !this.apenas_com_precos || this.planos.length != 1 || ( proced.precos[this.planos[0].id_plano] && proced.precos[this.planos[0].id_plano].valor > 0 ) ))
                .filter(item => !this.search || reg.test(JSON.stringify(item)));

            return retorno;
        },

        /*
        lista_tabelas: function () { 
            if ( this.tipo == 'P' ) { 

                if ( !this.particulares ) 
                    return [];

                return this.particulares.filter(item => !this.filtro_plano || item.id_plano == this.filtro_plano);

            }

            if ( !this.filtro_tabela || !this.tabelas ) 
                return this.tabelas;

            return this.tabelas.filter(item => item.id_tabela_versao == this.filtro_tabela);

        },
        */

        dadosFormatados: function () { 
            if ( !this.lista || !this.lista.length )
                return [];

            return this.lista.map(procedimento => { 
                let precos = {}

                if ( this.preco_detalhado && this.planos.length == 1 ) { 

                    if ( procedimento.precos[this.planos[0].id_plano].item_tabela ) { 
                        precos.codigo = procedimento.precos[this.planos[0].id_plano].item_tabela.st_codigo;
                        precos.porte_anestesico = procedimento.precos[this.planos[0].id_plano].item_tabela.in_porte_anestesico;
                        precos.auxiliares = procedimento.precos[this.planos[0].id_plano].item_tabela.in_numero_auxiliares;
                        precos.filme = this.$util.formatMoeda(procedimento.precos[this.planos[0].id_plano].item_tabela.dc_filme, 4);
                    }

                    precos.valor_filme = this.$util.formatMoeda(procedimento.precos[this.planos[0].id_plano].valor_filme);
                    precos.valor_hm = this.$util.formatMoeda(procedimento.precos[this.planos[0].id_plano].valor_hm);
                    precos.valor_co = this.$util.formatMoeda(procedimento.precos[this.planos[0].id_plano].valor_co);
                    precos.valor = this.$util.formatMoeda(procedimento.precos[this.planos[0].id_plano].valor);
                    precos.valor_matmed = this.$util.formatMoeda(this.consolidar_consumo(procedimento.precos[this.planos[0].id_plano], 'M'));
                    precos.valor_taxa = this.$util.formatMoeda(this.consolidar_consumo(procedimento.precos[this.planos[0].id_plano], 'T'));
                    precos.valor_total = this.$util.formatMoeda(
                        procedimento.precos[this.planos[0].id_plano].valor
                            + this.consolidar_consumo(procedimento.precos[this.planos[0].id_plano])
                    );

                } else { 
                
                    this.planos.forEach(plano => { 
                        precos[plano.search] = procedimento.precos[plano.id_plano] 
                            ? this.$util.formatMoeda(procedimento.precos[plano.id_plano].valor)
                            : null;

                        if ( this.preco_detalhado && procedimento.precos[plano.id_plano].item_tabela ) { 
                            precos.codigo = procedimento.precos[plano.id_plano].item_tabela.st_codigo;
                        }
                    });

                }
                
                return {
                    procedimento: procedimento.search, 
                    id: procedimento.id_procedimento, 
                    sigla: procedimento.st_sigla, 
                    ...precos, 
                };
            });
        },

        no_faturamento: function () { 
            return this.$route.path.substr(0,12) == '/faturamento';
        },

    },
    
    methods: { 
        tem_preco (item) { 
            return ( !this.apenas_com_precos || _.find(item.precos, preco => preco && preco.valor > 0) );
        },

        consolidar_consumo(preco, tipo = null) { 
            if ( !preco.consumos )
                return null;

            return preco.consumos.filter(consumo => 
                    ( consumo.id_taxa && tipo == 'T' ) 
                    || ( ( consumo.id_medicamento || consumo.id_material ) && tipo == 'M' ) 
                    || ( !tipo && ( consumo.id_medicamento || consumo.id_material || consumo.id_taxa ) )
                )
                .reduce((total, carry) => { 
                    return total + ( carry.dc_valor_unitario * carry.in_quantidade )
                }, 0);
        },

        abrir_item_tabela (item) {
            this.$refs.cadtab.abrirItemTabela(item.id_item_tabela, this.load);
        },

        exibir_moeda_corrente (item) { 
            console.log('ex', item);
            this.$refs.cadtab.exibir_moeda_corrente (item, item.tabela_operadora);
        },

        remover_plano (index) { 
            this.dados = null;
            this.planos.splice(index, 1);
        },

        incluir_plano (plano) { 
            if ( !plano || this.planos.find(item => item.id_plano == plano.id_plano) ) { 
                return;
            }

            this.dados = null;

            this.planos.push(plano);

            this.$nextTick(() => { 
                this.novo_plano = "";
            });
        },

        salvar_particular () { 

            this.$util.atualizar (this, { 
                service: 'unidade_procedimentos',
                func: 'store_valores_particular',
                dados: [
                    {
                        unidade_procedimento_planos: this.valor_partic,
                    }
                ],
                modal: 'valorParticularModal',
                reload: true, 
            });

        },

        editar_particular (item, plano, valor) { 
            this.valor_partic = null;

            this.$nextTick(() => { 
                this.valor_partic = _.cloneDeep(valor);
                this.procedimento = item;
                this.plano = plano;

                if ( !this.valor_partic ) { 
                    this.valor_partic = { 
                        id_unidade_procedimento_plano: null, 
                        id_unidade_procedimento: item.unidade_procedimento.id_unidade_procedimento, 
                        id_plano: plano.id_plano,
                        dc_valor: 0, 
                        fl_ativo: true, 
                    };
                }
    
                $('#valorParticularModal').modal('show');
            });
        },

        salvar_vinculacao () { 
            let pit = [ 
                { 
                    id_unidade: 1, 
                    procedimento_item_tabela: {  
                        id_procedimento_item_tabela: null, 
                        item_tabela: this.itemTabelaVinculo, 
                        id_item_tabela: this.itemTabelaVinculo.id_item_tabela,
                        id_procedimento: this.procedimento.id_procedimento,
                        fl_ativo: true,
                    }
                }
            ];

            this.$util.atualizar(this, { 
                service: 'procedimento_item_tabelas',
                func: 'store',
                dados: pit,
                modal: 'vincularProcModal',
                reload: true, 
            });
        },

        vincular (proc, tabela) { 
            this.itemTabelaVinculo = "";
            this.procedimento = proc;
            this.tabela = tabela;

            $('#vincularProcModal').modal('show');
        },

        exibir_campo(item, tabela) { 
            return _.get(this.validacao(item, tabela), 'item_tabela.' + this.campo_valid);
        },

        paginar (page) {
            this.page = page;
        },

        load() { 
            let opcao = this.especialidade 
                ? { where: { id_especialidade: this.especialidade.id_especialidade } }
                : {};

            this.$util.load(this, { 
                service: 'procedimentos',
                redir_api: true, 
                parms: { 
                    valid_preco_operadora: true, 
                    planos: this.planos.map(plano => plano.id_plano), 
                    id_unidade_operacao: this.id_unidade_operacao, 
                    ativos: true, 
                    ...opcao, 
                    tipo_proc: this.tipo_proc,
                    tipo_show_valor: this.tipo_show_valor, 
                    ...this.filtro
                }
            });

            // where: {  id_procedimento: 1000, },
        },

        validacao_partic (proc, plano) { 
            if ( !proc || !proc.unidade_procedimento || !proc.unidade_procedimento.unidade_procedimento_planos )
                return;

            return proc.unidade_procedimento.unidade_procedimento_planos
                .find(item => item.id_plano == plano.id_plano);
        },

        validacao(proc, tabela) { 
            if ( !proc || !proc.procedimento_item_tabela )
                return;

            return proc.procedimento_item_tabela.filter(item => item.fl_ativo)
                .find(item => item.item_tabela.fl_ativo && item.item_tabela.id_tabela_versao == tabela.id_tabela_versao);
        },

        acessarTabela (tabela, item, proc) { 
            if ( !item ) { 
                this.$refs.cadtab.incluirItemParaProcedimento(tabela, proc, this.load);
            } else { 
                this.$refs.cadtab.abrirItemTabela(item.id_item_tabela, this.load, tabela);
            }
        },

    },

    mounted() { 

        if ( this.no_faturamento ) { 

            this.breadcrumb = [
                    { name: "Faturamento", path: "/faturamento/guias"},
                    { name: "Preços", path: "/faturamento/precos" },
                ];

        } else { 

            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Validação Geral de Preços", path: "/cadastros" },
                ];

        }

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.valid_permissao(this, 101);

        if ( this.$route.params.id_operadora ) { 

            let filtros = { 
                id_operadora: this.$route.params.id_operadora,
                fl_ativo: true, 
            };

            if ( this.$route.params.id_plano ) { 
                filtros.id_plano = this.$route.params.id_plano;
            }

            this.$util.loadItem(this, { 
                service: 'planos',
                func: 'index',
                parms: { 
                    where: filtros, 
                },
            })
            .then(res => { 
                if ( res && res.length ) { 
                    this.incluir_plano(res[0]);
                }
            });

        }

        /*
        this.$util.load(this, { 
            service: 'tabela_versaos',
            parms: { 
                cadastro_procedimento: true,
                validacao: true,
            },
            loadTo: res => { 
                this.tabelas = res;
            }
        });
        */

        /*
        this.$util.load(this, { 
            service: 'planos',
            parms: { 
                where: { 
                    id_operadora: 1 
                }
            },
            loadTo: res => { 
                this.particulares = res;

                console.log('parm', this.$route.params.id_operadora);

                if ( this.$route.params.id_operadora ) { 
                    let pln = this.particulares.find(plano => plano.id_operadora == this.$route.params.id_operadora);

                    console.log('part', this.particulares);
                    console.log('pln', pln);

                    if ( pln ) { 
                        this.incluir_plano(pln);
                    }
                }
            }
        });
        */

    }
}
</script>
<style scoped>
.vertical-text {
    transform: rotate(90deg);
    transform-origin: left top 0;
}
</style>